<template>
  <div>
    <v-dialog v-model="getRlImageCloseDialog.show" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Close Edit Images</span>
        </v-card-title>
        <v-card-text>                  
          <v-container>
            <v-row>
              <v-col cols="12">
                <span>The changes will not be saved</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click.prevent="closeDialog()">Cancel</v-btn>
          <v-btn color="primary" @click.prevent="saveDialog()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {  	
	methods: {
        closeDialog() {
            this.setRlImageCloseDialog({ show: false, close: false })
        },
        saveDialog() {     
            this.setRlImageCloseDialog({ show: false, close: true })
        },
        ...mapActions([      
            'setRlImageCloseDialog'
        ])
	},
	computed: {
    ...mapGetters([
      'getRlImageCloseDialog',      
	])
  }
}
</script>

